import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { config } from '../../config';

export default function DashboardRH() {
    const [salaries, setSalaries] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showForm, setShowForm] = useState(false);
    const [editing, setEditing] = useState(null);
    const [form, setForm] = useState({
        nom: '', prenom: '', sexe: '', poste_initial: '', date_embauche: '',
        matricule: '', situation_matrimoniale: '', nombre_charges: 0,
        diplome: '', categorie: '', indice_initial: '', indice_actuel: '',
        service_affectation: '', telephone: '', numero_cnss: '', banque: '',
        numero_compte: '', poste2: '', commentaire: '',
        valeur_point_indiciaire: '', salaire_base: '', complement_solde: '',
        prime_anciennete: '', prime_service_public: '', indemnite_sujetion: '',
        indemnite_logement: '', indemnite_transport: '', prime_responsabilite: '',
        prime_caisse: '', prime_risque: '', prime_billetage: '', prime_magasinage: '',
        prime_salissure: '', prime_servitude: '', prime_garde: '', prime_lait: '',
        prime_eau: '', prime_electricite: '', prime_telephone: ''
    });

    const [showPdfDialog, setShowPdfDialog] = useState(false);
    const [signatureGauche, setSignatureGauche] = useState({ service: '', grade: '', nom: '' });
    const [cachetGaucheFile, setCachetGaucheFile] = useState(null);
    const [cachetGauchePreview, setCachetGauchePreview] = useState(null);
    const [signatureDroite, setSignatureDroite] = useState({ service: '', grade: '', nom: '' });
    const [cachetDroiteFile, setCachetDroiteFile] = useState(null);
    const [cachetDroitePreview, setCachetDroitePreview] = useState(null);
    const [logoFile, setLogoFile] = useState(null);
    const [logoPreview, setLogoPreview] = useState(null);

    // Utilisation de la configuration centralisée
    const API_BASE = `${config.apiBase}/rh`;

    const handleLogoChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setLogoFile(file);
            const reader = new FileReader();
            reader.onloadend = () => setLogoPreview(reader.result);
            reader.readAsDataURL(file);
        }
    };

    const handleCachetGaucheChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setCachetGaucheFile(file);
            const reader = new FileReader();
            reader.onloadend = () => setCachetGauchePreview(reader.result);
            reader.readAsDataURL(file);
        }
    };

    const handleCachetDroiteChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setCachetDroiteFile(file);
            const reader = new FileReader();
            reader.onloadend = () => setCachetDroitePreview(reader.result);
            reader.readAsDataURL(file);
        }
    };

    const fetchSalaries = async () => {
        try {
            const token = localStorage.getItem('token');
            const res = await fetch(`${API_BASE}/salaries_lister.php`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            const data = await res.json();
            if (data.success) setSalaries(data.salaries);
        } catch (error) {
            toast.error('Erreur chargement');
        } finally {
            setLoading(false);
        }
    };

    const openEdit = async (salarie) => {
        try {
            const token = localStorage.getItem('token');
            const res = await fetch(`${API_BASE}/salarie_get.php?id=${salarie.id_salarie}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            const data = await res.json();
            if (data.success) {
                setForm(data.salarie);
                setEditing(data.salarie.id_salarie);
                setShowForm(true);
            }
        } catch (error) {
            toast.error('Erreur chargement salarié');
        }
    };

    const handleDelete = async (id, nom) => {
        if (!window.confirm(`Supprimer définitivement ${nom} ?`)) return;
        const token = localStorage.getItem('token');
        try {
            const res = await fetch(`${API_BASE}/salarie_delete.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                body: JSON.stringify({ id_salarie: id })
            });
            const data = await res.json();
            if (data.success) {
                toast.success('Salarié supprimé');
                fetchSalaries();
            } else toast.error(data.message);
        } catch (error) {
            toast.error('Erreur suppression');
        }
    };

    const generatePDF = () => setShowPdfDialog(true);

    const fileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    };

    const confirmGeneratePDF = async () => {
        if (!signatureGauche.service || !signatureGauche.grade || !signatureGauche.nom ||
            !signatureDroite.service || !signatureDroite.grade || !signatureDroite.nom) {
            toast.error("Veuillez remplir tous les champs des deux signatures.");
            return;
        }

        let logoBase64 = '';
        if (logoFile) logoBase64 = await fileToBase64(logoFile);
        let cachetGaucheBase64 = '';
        if (cachetGaucheFile) cachetGaucheBase64 = await fileToBase64(cachetGaucheFile);
        let cachetDroiteBase64 = '';
        if (cachetDroiteFile) cachetDroiteBase64 = await fileToBase64(cachetDroiteFile);

        const printContent = `<!DOCTYPE html>
        <html>
        <head>
            <meta charset="UTF-8">
            <title>Liste des salariés CROUS Dosso</title>
            <style>
                @page { size: landscape; margin: 2.5cm; }
                body { font-family: 'Times New Roman', 'Georgia', serif; margin: 0; padding: 0; line-height: 1.4; position: relative; }
                .watermark { position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); opacity: 0.08; z-index: -1; width: 350px; height: auto; pointer-events: none; }
                .header { text-align: center; margin-bottom: 25px; border-bottom: 2px solid #1e3a8a; padding-bottom: 12px; position: relative; }
                .header-logo { position: absolute; left: 0; top: 0; width: 65px; height: auto; opacity: 1; }
                .republic { font-size: 13px; font-weight: bold; color: #1e3a8a; letter-spacing: 1px; }
                .ministere { font-size: 11px; font-style: italic; }
                .crous { font-size: 14px; font-weight: bold; margin-top: 5px; color: #166534; }
                .title { font-size: 16px; font-weight: bold; margin: 15px 0 10px; text-decoration: underline; color: #1e3a8a; }
                table { width: 100%; border-collapse: collapse; font-size: 9px; margin-top: 15px; }
                th, td { border: 1px solid #333; padding: 6px 4px; text-align: left; vertical-align: top; }
                th { background-color: #dbeafe; font-weight: bold; color: #1e3a8a; }
                .signatures-container { margin-top: 45px; display: flex; justify-content: space-between; position: relative; }
                .signature-box { text-align: center; width: 45%; border-top: 1px dashed #888; padding-top: 20px; position: relative; }
                .signature-line { margin: 5px 0; font-size: 12px; }
                .cachet { position: absolute; right: -20px; bottom: -10px; width: 80px; height: auto; opacity: 0.7; }
                footer { margin-top: 25px; text-align: center; font-size: 8px; color: #777; border-top: 1px solid #ccc; padding-top: 8px; }
            </style>
        </head>
        <body>
            ${logoBase64 ? `<img src="${logoBase64}" class="watermark" alt="Watermark" />` : ''}
            <div class="header">
                ${logoBase64 ? `<img src="${logoBase64}" class="header-logo" alt="Logo CROUS" />` : ''}
                <div class="republic">RÉPUBLIQUE DU NIGER</div>
                <div class="ministere">Ministère de l'Enseignement Supérieur de la Recherche et de l'Innovation Technologique</div>
                <div class="crous">UNIVERSITE DE DOSSO</div>
                <div class="crous">CENTRE RÉGIONAL DES ŒUVRES UNIVERSITAIRES (CROU) DE DOSSO</div>
                <div class="title">LISTE GÉNÉRALE DES SALARIÉS</div>
            </div>
            <table style="width:100%; border-collapse:collapse; font-size:9px; margin-top:15px;">
                <thead>
                    <tr style="background-color:#dbeafe;">
                        <th>Matricule</th>
                        <th>Nom</th>
                        <th>Prénom</th>
                        <th>Poste initial</th>
                        <th>Date embauche</th>
                        <th>Situation matrimoniale</th>
                        <th>Nb charges</th>
                        <th>Diplôme</th>
                        <th>Catégorie</th>
                        <th>Service affectation</th>
                        <th>Téléphone</th>
                        <th>CNSS</th>
                        <th>Banque</th>
                        <th>Indice actuel</th>
                        <th>Commentaire</th>
                    </tr>
                </thead>
                <tbody>
                    ${salaries.map(s => `
                        <tr>
                            <td style="border:1px solid #333; padding:4px;">${s.matricule || ''}</td>
                            <td style="border:1px solid #333; padding:4px;">${s.nom || ''}</td>
                            <td style="border:1px solid #333; padding:4px;">${s.prenom || ''}</td>
                            <td style="border:1px solid #333; padding:4px;">${s.poste_initial || ''}</td>
                            <td style="border:1px solid #333; padding:4px;">${s.date_embauche || ''}</td>
                            <td style="border:1px solid #333; padding:4px;">${s.situation_matrimoniale || ''}</td>
                            <td style="border:1px solid #333; padding:4px;">${s.nombre_charges || 0}</td>
                            <td style="border:1px solid #333; padding:4px;">${s.diplome || ''}</td>
                            <td style="border:1px solid #333; padding:4px;">${s.categorie || ''}</td>
                            <td style="border:1px solid #333; padding:4px;">${s.service_affectation || ''}</td>
                            <td style="border:1px solid #333; padding:4px;">${s.telephone || ''}</td>
                            <td style="border:1px solid #333; padding:4px;">${s.numero_cnss || ''}</td>
                            <td style="border:1px solid #333; padding:4px;">${s.banque || ''}</td>
                            <td style="border:1px solid #333; padding:4px;">${s.indice_actuel || '-'}</td>
                            <td style="border:1px solid #333; padding:4px;">${s.commentaire || '-'}</td>
                        </tr>
                    `).join('')}
                </tbody>
            </table>
            <div class="signatures-container">
                <div class="signature-box">
                    <div class="signature-line">Fait à Dosso, le ${new Date().toLocaleDateString('fr-FR')}</div>
                    <div class="signature-line" style="margin-top:15px;"><strong>${signatureGauche.service}</strong></div>
                    <div class="signature-line">${signatureGauche.grade}</div>
                    <div class="signature-line" style="text-decoration:underline; margin-bottom:10px;">${signatureGauche.nom}</div>
                    ${cachetGaucheBase64 ? `<img src="${cachetGaucheBase64}" class="cachet" alt="Cachet gauche" />` : ''}
                </div>
                <div class="signature-box">
                    <div class="signature-line">Fait à Dosso, le ${new Date().toLocaleDateString('fr-FR')}</div>
                    <div class="signature-line" style="margin-top:15px;"><strong>${signatureDroite.service}</strong></div>
                    <div class="signature-line">${signatureDroite.grade}</div>
                    <div class="signature-line" style="text-decoration:underline; margin-bottom:10px;">${signatureDroite.nom}</div>
                    ${cachetDroiteBase64 ? `<img src="${cachetDroiteBase64}" class="cachet" alt="Cachet droit" />` : ''}
                </div>
            </div>
            <footer>Document généré par le système intégré de gestion du CROUS Dosso</footer>
        </body>
        </html>`;

        const printWindow = window.open('', '_blank');
        if (!printWindow) { toast.error("Veuillez autoriser les popups pour générer le PDF"); return; }
        printWindow.document.write(printContent);
        printWindow.document.close();
        printWindow.print();
        toast.success("PDF généré avec succès");
        setShowPdfDialog(false);
    };

    const recalculerSalaire = (updatedForm) => {
        const point = parseFloat(updatedForm.valeur_point_indiciaire) || 0;
        const indice = parseFloat(updatedForm.indice_actuel) || 0;
        const salaireBase = point * indice;
        updatedForm.salaire_base = salaireBase;

        let complement = 0;
        if (salaireBase < 80000) complement = salaireBase * 0.25;
        else complement = salaireBase * 0.10;
        updatedForm.complement_solde = complement;

        const primes = [
            'prime_anciennete', 'prime_service_public', 'indemnite_sujetion',
            'indemnite_logement', 'indemnite_transport', 'prime_responsabilite',
            'prime_caisse', 'prime_risque', 'prime_billetage', 'prime_magasinage',
            'prime_salissure', 'prime_servitude', 'prime_garde', 'prime_lait',
            'prime_eau', 'prime_electricite', 'prime_telephone'
        ];
        let totalPrimes = primes.reduce((acc, p) => acc + (parseFloat(updatedForm[p]) || 0), 0);
        updatedForm.salaire_brut_calcule = salaireBase + complement + totalPrimes;
        return updatedForm;
    };

    const handleChange = (e) => {
        const value = e.target.type === 'number' ? parseFloat(e.target.value) || 0 : e.target.value;
        let updated = { ...form, [e.target.name]: value };
        updated = recalculerSalaire(updated);
        setForm(updated);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem('token');
            const url = editing ? `${API_BASE}/salarie_update.php` : `${API_BASE}/salaries_ajouter.php`;
            const payload = editing ? { ...form, id_salarie: editing } : form;
            const res = await fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                body: JSON.stringify(payload)
            });
            const data = await res.json();
            if (data.success) {
                toast.success(editing ? 'Salarié modifié' : 'Salarié ajouté');
                setShowForm(false);
                setEditing(null);
                setForm({
                    nom: '', prenom: '', sexe: '', poste_initial: '', date_embauche: '',
                    matricule: '', situation_matrimoniale: '', nombre_charges: 0,
                    diplome: '', categorie: '', indice_initial: '', indice_actuel: '',
                    service_affectation: '', telephone: '', numero_cnss: '', banque: '',
                    numero_compte: '', poste2: '', commentaire: '',
                    valeur_point_indiciaire: '', salaire_base: '', complement_solde: '',
                    prime_anciennete: '', prime_service_public: '', indemnite_sujetion: '',
                    indemnite_logement: '', indemnite_transport: '', prime_responsabilite: '',
                    prime_caisse: '', prime_risque: '', prime_billetage: '', prime_magasinage: '',
                    prime_salissure: '', prime_servitude: '', prime_garde: '', prime_lait: '',
                    prime_eau: '', prime_electricite: '', prime_telephone: ''
                });
                fetchSalaries();
            } else toast.error(data.message || 'Erreur');
        } catch (error) {
            toast.error('Erreur réseau');
        }
    };

    useEffect(() => { fetchSalaries(); }, []);

    if (loading) return <div className="p-6 text-center">Chargement...</div>;

    const columns = [
        'matricule', 'nom', 'prenom', 'poste_initial', 'service_affectation',
        'telephone', 'numero_cnss', 'indice_actuel', 'commentaire'
    ];

    const columnLabels = {
        matricule: 'Matricule', nom: 'Nom', prenom: 'Prénom',
        poste_initial: 'Poste', service_affectation: 'Service',
        telephone: 'Téléphone', numero_cnss: 'CNSS',
        indice_actuel: 'Indice actuel', commentaire: 'Commentaire'
    };

    return (
        <div className="p-6">
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-2xl font-bold text-blue-800">📋 Gestion RH – Salariés</h1>
                <div className="space-x-2">
                    <button onClick={generatePDF} className="bg-green-700 text-white px-4 py-2 rounded shadow hover:bg-green-800">📄 Exporter en PDF</button>
                    <button onClick={() => { setEditing(null); setForm({
                        nom: '', prenom: '', sexe: '', poste_initial: '', date_embauche: '',
                        matricule: '', situation_matrimoniale: '', nombre_charges: 0,
                        diplome: '', categorie: '', indice_initial: '', indice_actuel: '',
                        service_affectation: '', telephone: '', numero_cnss: '', banque: '',
                        numero_compte: '', poste2: '', commentaire: '',
                        valeur_point_indiciaire: '', salaire_base: '', complement_solde: '',
                        prime_anciennete: '', prime_service_public: '', indemnite_sujetion: '',
                        indemnite_logement: '', indemnite_transport: '', prime_responsabilite: '',
                        prime_caisse: '', prime_risque: '', prime_billetage: '', prime_magasinage: '',
                        prime_salissure: '', prime_servitude: '', prime_garde: '', prime_lait: '',
                        prime_eau: '', prime_electricite: '', prime_telephone: ''
                    }); setShowForm(true); }} className="bg-blue-600 text-white px-4 py-2 rounded shadow hover:bg-blue-700">+ Ajouter un salarié</button>
                </div>
            </div>

            <div className="overflow-x-auto bg-white rounded-xl shadow">
                <table className="min-w-full text-sm">
                    <thead className="bg-gray-100">
                        <tr>
                            {columns.map(col => <th key={col} className="p-2 whitespace-nowrap">{columnLabels[col]}</th>)}
                            <th className="p-2">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {salaries.map(s => (
                            <tr key={s.id_salarie} className="border-b hover:bg-gray-50">
                                {columns.map(col => <td key={col} className="p-2 whitespace-nowrap">{s[col] || '-'}</td>)}
                                <td className="p-2 whitespace-nowrap">
                                    <button onClick={() => openEdit(s)} className="text-blue-600 mr-2 hover:underline">✏️</button>
                                    <button onClick={() => handleDelete(s.id_salarie, s.nom)} className="text-red-500 hover:underline">🗑️</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {showForm && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto p-6">
                        <h2 className="text-xl font-bold mb-4">{editing ? '✏️ Modifier salarié' : '➕ Nouveau salarié'}</h2>
                        <form onSubmit={handleSubmit} className="grid grid-cols-2 gap-4">
                            <div className="col-span-2 bg-blue-50 p-3 rounded font-bold text-blue-800 mt-2">🧑‍💼 Informations personnelles</div>
                            
                            <div><label className="block text-sm font-medium">Nom *</label><input name="nom" value={form.nom} onChange={handleChange} className="border p-2 rounded w-full" required /></div>
                            <div><label className="block text-sm font-medium">Prénom *</label><input name="prenom" value={form.prenom} onChange={handleChange} className="border p-2 rounded w-full" required /></div>
                            <div><label className="block text-sm font-medium">Sexe *</label><select name="sexe" value={form.sexe} onChange={handleChange} className="border p-2 rounded w-full" required><option value="">Sélectionner</option><option value="M">Masculin</option><option value="F">Féminin</option></select></div>
                            <div><label className="block text-sm font-medium">Poste initial *</label><input name="poste_initial" value={form.poste_initial} onChange={handleChange} className="border p-2 rounded w-full" required /></div>
                            <div><label className="block text-sm font-medium">Date d'embauche *</label><input name="date_embauche" type="date" value={form.date_embauche} onChange={handleChange} className="border p-2 rounded w-full" required /></div>
                            <div><label className="block text-sm font-medium">Matricule *</label><input name="matricule" value={form.matricule} onChange={handleChange} className="border p-2 rounded w-full" required /></div>
                            <div><label className="block text-sm font-medium">Situation matrimoniale *</label><select name="situation_matrimoniale" value={form.situation_matrimoniale} onChange={handleChange} className="border p-2 rounded w-full" required><option value="">Sélectionner</option><option value="celibataire">Célibataire</option><option value="marie(e)">Marié(e)</option><option value="divorce(e)">Divorcé(e)</option><option value="veuf(ve)">Veuf(ve)</option></select></div>
                            <div><label className="block text-sm font-medium">Nombre de charges</label><input name="nombre_charges" type="number" value={form.nombre_charges} onChange={handleChange} className="border p-2 rounded w-full" /></div>
                            <div><label className="block text-sm font-medium">Diplôme</label><input name="diplome" value={form.diplome} onChange={handleChange} className="border p-2 rounded w-full" /></div>
                            <div><label className="block text-sm font-medium">Catégorie</label><input name="categorie" value={form.categorie} onChange={handleChange} className="border p-2 rounded w-full" /></div>
                            <div><label className="block text-sm font-medium">Service affectation</label><input name="service_affectation" value={form.service_affectation} onChange={handleChange} className="border p-2 rounded w-full" /></div>
                            <div><label className="block text-sm font-medium">Téléphone</label><input name="telephone" value={form.telephone} onChange={handleChange} className="border p-2 rounded w-full" /></div>
                            <div><label className="block text-sm font-medium">Numéro CNSS</label><input name="numero_cnss" value={form.numero_cnss} onChange={handleChange} className="border p-2 rounded w-full" /></div>
                            <div><label className="block text-sm font-medium">Banque</label><input name="banque" value={form.banque} onChange={handleChange} className="border p-2 rounded w-full" /></div>
                            <div><label className="block text-sm font-medium">Numéro de compte</label><input name="numero_compte" value={form.numero_compte} onChange={handleChange} className="border p-2 rounded w-full" /></div>
                            <div><label className="block text-sm font-medium">Poste secondaire</label><input name="poste2" value={form.poste2} onChange={handleChange} className="border p-2 rounded w-full" /></div>
                            <div className="col-span-2"><label className="block text-sm font-medium">Commentaire</label><textarea name="commentaire" rows="2" value={form.commentaire} onChange={handleChange} className="border p-2 rounded w-full" /></div>

                            <div className="col-span-2 bg-green-50 p-3 rounded font-bold text-green-800 mt-4">📈 Paramètres de paie</div>
                            <div><label className="block text-sm font-medium">Indice initial</label><input name="indice_initial" type="number" value={form.indice_initial} onChange={handleChange} className="border p-2 rounded w-full" /></div>
                            <div><label className="block text-sm font-medium">Indice actuel</label><input name="indice_actuel" type="number" value={form.indice_actuel} onChange={handleChange} className="border p-2 rounded w-full" /></div>
                            <div><label className="block text-sm font-medium">Valeur point indiciaire</label><input name="valeur_point_indiciaire" type="number" value={form.valeur_point_indiciaire} onChange={handleChange} className="border p-2 rounded w-full" /></div>
                            <div><label className="block text-sm font-medium">Salaire de base (auto)</label><input name="salaire_base" type="number" value={form.salaire_base} className="border p-2 rounded w-full bg-gray-100" disabled /></div>
                            <div><label className="block text-sm font-medium">Complément solde (auto)</label><input name="complement_solde" type="number" value={form.complement_solde} className="border p-2 rounded w-full bg-gray-100" disabled /></div>

                            <div className="col-span-2 bg-yellow-50 p-3 rounded font-bold text-yellow-800 mt-4">💰 Primes et indemnités</div>
                            <div><label className="block text-sm font-medium">Prime ancienneté</label><input name="prime_anciennete" type="number" value={form.prime_anciennete} onChange={handleChange} className="border p-2 rounded w-full" /></div>
                            <div><label className="block text-sm font-medium">Prime service public</label><input name="prime_service_public" type="number" value={form.prime_service_public} onChange={handleChange} className="border p-2 rounded w-full" /></div>
                            <div><label className="block text-sm font-medium">Indemnité sujétion</label><input name="indemnite_sujetion" type="number" value={form.indemnite_sujetion} onChange={handleChange} className="border p-2 rounded w-full" /></div>
                            <div><label className="block text-sm font-medium">Indemnité logement</label><input name="indemnite_logement" type="number" value={form.indemnite_logement} onChange={handleChange} className="border p-2 rounded w-full" /></div>
                            <div><label className="block text-sm font-medium">Indemnité transport</label><input name="indemnite_transport" type="number" value={form.indemnite_transport} onChange={handleChange} className="border p-2 rounded w-full" /></div>
                            <div><label className="block text-sm font-medium">Prime responsabilité</label><input name="prime_responsabilite" type="number" value={form.prime_responsabilite} onChange={handleChange} className="border p-2 rounded w-full" /></div>
                            <div><label className="block text-sm font-medium">Prime caisse</label><input name="prime_caisse" type="number" value={form.prime_caisse} onChange={handleChange} className="border p-2 rounded w-full" /></div>
                            <div><label className="block text-sm font-medium">Prime risque</label><input name="prime_risque" type="number" value={form.prime_risque} onChange={handleChange} className="border p-2 rounded w-full" /></div>
                            <div><label className="block text-sm font-medium">Prime billetage</label><input name="prime_billetage" type="number" value={form.prime_billetage} onChange={handleChange} className="border p-2 rounded w-full" /></div>
                            <div><label className="block text-sm font-medium">Prime magasinage</label><input name="prime_magasinage" type="number" value={form.prime_magasinage} onChange={handleChange} className="border p-2 rounded w-full" /></div>
                            <div><label className="block text-sm font-medium">Prime salissure</label><input name="prime_salissure" type="number" value={form.prime_salissure} onChange={handleChange} className="border p-2 rounded w-full" /></div>
                            <div><label className="block text-sm font-medium">Prime servitude</label><input name="prime_servitude" type="number" value={form.prime_servitude} onChange={handleChange} className="border p-2 rounded w-full" /></div>
                            <div><label className="block text-sm font-medium">Prime garde</label><input name="prime_garde" type="number" value={form.prime_garde} onChange={handleChange} className="border p-2 rounded w-full" /></div>
                            <div><label className="block text-sm font-medium">Prime lait</label><input name="prime_lait" type="number" value={form.prime_lait} onChange={handleChange} className="border p-2 rounded w-full" /></div>
                            <div><label className="block text-sm font-medium">Prime eau</label><input name="prime_eau" type="number" value={form.prime_eau} onChange={handleChange} className="border p-2 rounded w-full" /></div>
                            <div><label className="block text-sm font-medium">Prime électricité</label><input name="prime_electricite" type="number" value={form.prime_electricite} onChange={handleChange} className="border p-2 rounded w-full" /></div>
                            <div><label className="block text-sm font-medium">Prime téléphone</label><input name="prime_telephone" type="number" value={form.prime_telephone} onChange={handleChange} className="border p-2 rounded w-full" /></div>
                            <div><label className="block text-sm font-medium">Salaire brut calculé (auto)</label><input name="salaire_brut_calcule" type="number" value={form.salaire_brut_calcule} className="border p-2 rounded w-full bg-gray-100" disabled /></div>

                            <div className="col-span-2 flex justify-end gap-2 mt-4">
                                <button type="button" onClick={() => setShowForm(false)} className="bg-gray-400 text-white px-4 py-2 rounded">Annuler</button>
                                <button type="submit" className="bg-green-600 text-white px-4 py-2 rounded">{editing ? 'Modifier' : 'Ajouter'}</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {showPdfDialog && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-xl w-full max-w-md p-6" style={{ maxHeight: '90vh', overflowY: 'auto' }}>
                        <h2 className="text-xl font-bold mb-4 sticky top-0 bg-white pb-2">Informations de signature</h2>
                        <div className="mb-4"><label className="block text-sm font-medium mb-1">Logo entête (filigrane + entête)</label><input type="file" accept="image/*" onChange={handleLogoChange} className="w-full border p-2 rounded" />{logoPreview && <img src={logoPreview} alt="Logo" className="mt-2 h-16 object-contain" />}</div>
                        <hr className="my-4" />
                        <div className="border-l-4 border-blue-500 pl-4 mb-6"><h3 className="font-bold text-blue-700 mb-3">🖊️ Signature (gauche)</h3><input type="text" placeholder="Service / Titre" className="w-full border p-2 rounded mb-2" value={signatureGauche.service} onChange={e => setSignatureGauche({ ...signatureGauche, service: e.target.value })} /><input type="text" placeholder="Grade" className="w-full border p-2 rounded mb-2" value={signatureGauche.grade} onChange={e => setSignatureGauche({ ...signatureGauche, grade: e.target.value })} /><input type="text" placeholder="Nom complet" className="w-full border p-2 rounded mb-2" value={signatureGauche.nom} onChange={e => setSignatureGauche({ ...signatureGauche, nom: e.target.value })} /><div><label className="block text-sm font-medium mb-1">Cachet (optionnel)</label><input type="file" accept="image/*" onChange={handleCachetGaucheChange} className="w-full border p-2 rounded" />{cachetGauchePreview && <img src={cachetGauchePreview} alt="Cachet gauche" className="mt-2 h-16 object-contain" />}</div></div>
                        <div className="border-l-4 border-green-500 pl-4"><h3 className="font-bold text-green-700 mb-3">🖊️ Signature (droite)</h3><input type="text" placeholder="Service / Titre" className="w-full border p-2 rounded mb-2" value={signatureDroite.service} onChange={e => setSignatureDroite({ ...signatureDroite, service: e.target.value })} /><input type="text" placeholder="Grade" className="w-full border p-2 rounded mb-2" value={signatureDroite.grade} onChange={e => setSignatureDroite({ ...signatureDroite, grade: e.target.value })} /><input type="text" placeholder="Nom complet" className="w-full border p-2 rounded mb-2" value={signatureDroite.nom} onChange={e => setSignatureDroite({ ...signatureDroite, nom: e.target.value })} /><div><label className="block text-sm font-medium mb-1">Cachet (optionnel)</label><input type="file" accept="image/*" onChange={handleCachetDroiteChange} className="w-full border p-2 rounded" />{cachetDroitePreview && <img src={cachetDroitePreview} alt="Cachet droit" className="mt-2 h-16 object-contain" />}</div></div>
                        <div className="flex justify-end gap-2 mt-6 sticky bottom-0 bg-white pt-2"><button onClick={() => setShowPdfDialog(false)} className="bg-gray-400 text-white px-4 py-2 rounded">Annuler</button><button onClick={confirmGeneratePDF} className="bg-green-600 text-white px-4 py-2 rounded">Générer le PDF</button></div>
                    </div>
                </div>
            )}
        </div>
    );
}